import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_BEGIN,
  SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_SUCCESS,
  SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_FAILURE,
  SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function loadExternalApisInSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_BEGIN,
    });
    const { projectId, version } = args;
    let header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/`;
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalApisInScheduleError() {
  return {
    type: SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_BEGIN:
      return {
        ...state,
        loadExternalApisInSchedulePending: true,
        loadExternalApisInScheduleError: null,
      };

    case SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadExternalApisInSchedulePending: false,
        loadExternalApisInScheduleError: null,
        externalApis: action.data,
      };

    case SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_FAILURE:
      return {
        ...state,
        loadExternalApisInSchedulePending: false,
        loadExternalApisInScheduleError: action.data.error,
      };

    case SCHEDULE_LOAD_EXTERNAL_APIS_IN_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        loadExternalApisInScheduleError: null,
      };

    default:
      return state;
  }
}
